import React from 'react';

//Components
import Menu from './Menu';
import Botones from './Botones';
//Context
import { ReportesProvider, useReportes } from './ReportesContex';
import '../../styles/reportes.css';
import SkuOrden from './SkuOrden';
import Corridas from './Corridas';
import Tiempos from './Tiempos';
import Porcentajes from './Porcentajes';
import Informe2 from './Informe2';
import LineaTiempoV2 from './LineaTiempoV2';
import InformeProduccion from './InformeProduccion';
import ReporteOperacion from './ReporteOperacion';

const setColor = (newColor) => {
    document.documentElement.style.setProperty('--color', newColor);
};

function Reportes() {
    const { selectedIndex } = useReportes();

    let primColor = '';
    if (process.env.REACT_APP_THEME === 'tecnoTheme') {
        primColor = '#ff9800';
        setColor(primColor);
    } else if (process.env.REACT_APP_THEME === 'posTheme') {
        primColor = '#00638D';
        setColor(primColor);
    } else if (process.env.REACT_APP_THEME === 'vaisandTheme') {
        primColor = '#1959D9';
        setColor(primColor);
    } else {
        primColor = '#903bff';
        setColor(primColor);
    }

    return (
        <div className="reportesView">
            <div className="reportesView-menu">
                <div className="reportesView-menu-head">
                    <h1 className="titulo">Reportes</h1>
                </div>
                <div className="reportesView-menu-body">
                    <Menu />
                </div>
            </div>
            <div className="reportesView-body">
                <div className="reportesView-body-head">
                    <Botones />
                </div>

                <div className="reportesView-body-graph">
                    {selectedIndex === 1 && process.env.REACT_APP_ALLOW_REPORTS_PRODUCTION_REPORT === 'true' && <SkuOrden />}
                    {selectedIndex === 2 && process.env.REACT_APP_ALLOW_REPORTS_CORRIDAS_REPORT === 'true' && <Corridas />}
                    {selectedIndex === 3 && process.env.REACT_APP_ALLOW_REPORTS_LOST_TIMES === 'true' && <Tiempos />}
                    {selectedIndex === 4 && process.env.REACT_APP_ALLOW_REPORTS_MTBF_MTTR === 'true' && <Porcentajes />}
                    {selectedIndex === 5 && process.env.REACT_APP_ALLOW_REPORTS_TIMELINE === 'true' && <LineaTiempoV2 />}
                    {/* {selectedIndex === 6 && process.env.REACT_APP_ALLOW_REPORTS_TIMELINEV1 === 'true' &&  <LineaTiempo />} */}
                    {selectedIndex === 7 && process.env.REACT_APP_ALLOW_REPORTS_INFORME2 === 'true' && <Informe2 />}
                    {selectedIndex === 8 && process.env.REACT_APP_ALLOW_REPORTS_INFORME_PRODUCCION === 'true' && <InformeProduccion />}
                    {selectedIndex === 9 && process.env.REACT_APP_ALLOW_REPORTS_OPERACION === 'true' && <ReporteOperacion />}
                </div>
            </div>
        </div>
    );
}

let ReportesProviderComp = () => (
    <ReportesProvider>
        <Reportes></Reportes>
    </ReportesProvider>
);

export default ReportesProviderComp;
